import AccountCircleOutlined from '@mui/icons-material/AccountCircleOutlined';
import ForumOutlined from '@mui/icons-material/ForumOutlined';
import HomeOutlined from '@mui/icons-material/HomeOutlined';
import ShowChartOutlined from '@mui/icons-material/ShowChartOutlined';

/** The four tabs of the Mini App, in display order (mockup 1, task split S1). */
export const TABS = [
  { path: '/', titleKey: 'tabs.home', Icon: HomeOutlined },
  { path: '/channels', titleKey: 'tabs.channels', Icon: ForumOutlined },
  { path: '/positions', titleKey: 'tabs.positions', Icon: ShowChartOutlined },
  { path: '/account', titleKey: 'tabs.account', Icon: AccountCircleOutlined },
] as const;
